import React from "react";
import { withTranslation } from 'react-i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import Footer from "../../Footer/FooterBottom";
import SubMenu from "./SubMenu";
import LessonItem from "./LessonItem";
import TreeView from "../../Admin/Indices/TreeView";
import { fetchIndices } from '../../Admin/Indices/actions';
import { getIndeices, setIndeices } from "../../../context/sessionStorage";

import {
    fetchLessons as fetch,
    setLessonFavorite as setFavorite
} from '../../Admin/Lessons/actions';
import history from '../../../history';
import { fetchClassRooms } from '../../School/ClassRooms/actions';
import { fetchStudentInClassRooms } from '../../School/StudentInClassRooms/actions';

class List extends React.Component {

    state = { currentItem: '', indices: [], search: '', selectedTopicIds: [] };

    componentDidMount() {
        let indices = getIndeices();
        if (indices === null || indices.length === 0) {
            this.props.fetchIndices();
        }
        this.setState({
            indices: indices
        });

        const { indexId } = this.props.match.params;
        if (indexId !== '0') {
            this.setState({
                currentItem: {
                    id: parseInt(indexId)
                }
            });
            this.props.fetch(indexId);
        }

        window.scrollToPosition(`main-${this.props.typeOfList}-section`);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.user &&
            props.user.user &&
            props.user.user.UserType &&
            (props.user.user.UserType.Id === 3 || props.user.user.UserType.Id === 4) &&
            props.classRooms && props.classRooms.length === 0) {
            props.fetchClassRooms();
        }
        return state;
    }

    setCurrentItem = item => {
        this.setState({ currentItem: item, search: "", selectedTopicIds: [] });
        this.props.fetch(item.id);

        if (this.props.type === "BookLessons") {
            history.push(`/Tracks/BookLessons/${item.id}`);
        } else {
            history.push(`${this.props.Link}${item.id}`);
        }
    }

    Sync = () => {
        if (this.state.currentItem) {
            this.props.fetch(this.state.currentItem.id);
        }
    }

    setSearch = value => {
        this.setState({
            search: value
        });
    }

    GetNode(nodes, Id) {
        var result = false;
        if (nodes) {
            nodes.forEach(node => {
                if (node.id === Id && node.Level >= 1) {
                    result = node.nodes;
                }
            });
            if (result) {
                return result;
            }
            nodes.forEach(node => {
                var subResult = this.GetNode(node.nodes, Id);
                if (subResult) {
                    result = subResult;
                    return false;
                }
            });
        }
        return result;
    }

    fetchStudentInClassRooms = (ClassRoomId, MediaId) => {
        this.props.fetchStudentInClassRooms(ClassRoomId, MediaId);
    }

    setFavorite = id => {
        this.props.setFavorite(id);
    }

    renderLessons() {
        const { t, user, classRooms } = this.props;
        let lessons = this.props.lessons;
        let isLoaded = false;

        if (lessons) {
            isLoaded = lessons.isLoaded;
        }

        let toRemove = [];
        if (lessons) {
            toRemove = lessons.toRemove;
        }

        let indices = this.props.indices;
        if (indices) {
            setIndeices(indices);
        } else {
            indices = this.state.indices;
        }

        const getLessonTopics = (lesson) => {
            return lesson.Topics || [];
        };

        if (lessons && lessons.lessons && lessons.lessons.length > 0 && this.state.currentItem) {
            let searchText = this.state.search.replace(/([ًٌٍَُِّْ])/g, "").replace(/([أإٱآ])/g, "ا");
            let filterLesson = lessons.lessons.filter(v => {
                const matchesSearch = v.SearchName.includes(searchText) && v.Index.Id === this.state.currentItem.id;
                if (!matchesSearch) return false;
                if (this.state.selectedTopicIds && this.state.selectedTopicIds.length > 0) {
                    const topics = getLessonTopics(v);
                    return topics.some(t => this.state.selectedTopicIds.includes(t.TopicId));
                }
                return true;
            });

            if (isLoaded === false) {
                return (
                    <div className="product-list-item" >
                        <div className="product-content w-100 text-center ">
                            <div className="display-1 text-danger">
                                <i className="fad fa-sync-alt fa-spin"></i>
                            </div>
                            <h4 className="display-3 subtitle">
                                {t("Pages." + this.props.typeOfList + ".Loading")}
                            </h4>
                        </div>
                    </div>
                );
            }

            if (filterLesson.length === 0 && this.state.search) {
                return (
                    <div className="product-list-item" >
                        <div className="product-content w-100 text-center ">
                            <div className="display-1 text-danger">
                                <i className="fad fa-telescope"></i>
                            </div>
                            <h4 className=" subtitle">
                                {t("Pages." + this.props.typeOfList + ".NotFound")}
                            </h4>
                            <div className="h2 text-danger">
                                "{this.state.search}"
                                {t("Pages." + this.props.typeOfList + ".IsNotHere")}
                            </div>
                        </div>
                    </div>
                );
            }

            if (filterLesson.length === 0) {
                if (indices && indices.nodes && this.state.currentItem) {
                    return this.renderTreeNode(indices);
                }
                return (
                    <div className="product-list-item" >
                        <div className="product-content w-100 text-center ">
                            <div className="display-1 text-danger">
                                <i className="fad fa-telescope"></i>
                            </div>
                            <h4 className="display-3 subtitle">
                                {t("Pages." + this.props.typeOfList + ".NotFound")}
                            </h4>
                        </div>
                    </div>
                );
            }

            return <>
                {this.renderTreeNode(indices)}
                {this.renderSubLessons(true, filterLesson, toRemove, classRooms, user, indices)}
                {this.renderSubLessons(false, filterLesson, toRemove, classRooms, user, indices)}
            </>;
        }
        if (!this.state.currentItem) {
            return (
                <div className="product-list-item" >
                    <div className="product-content w-100 text-center ">
                        <div className="display-1 text-danger">
                            <i className="fad fa-glasses "></i>
                        </div>
                        <h4 className="display-3 subtitle">
                            {t("Pages." + this.props.typeOfList + ".SelectIndex")}
                        </h4>
                    </div>
                </div>
            );
        }
        if (lessons && lessons.isLoaded === false) {
            return (
                <div className="product-list-item" >
                    <div className="product-content w-100 text-center ">
                        <div className="display-1 text-danger">
                            <i className="fad fa-sync-alt fa-spin"></i>
                        </div>
                        <h4 className="display-3 subtitle">
                            {t("Pages." + this.props.typeOfList + ".Loading")}
                        </h4>
                    </div>
                </div>
            );
        }

        if (indices && indices.nodes) {
            return this.renderTreeNode(indices);
        }

        return (
            <div className="product-list-item" >
                <div className="product-content w-100 text-center ">
                    <div className="display-1 text-danger">
                        <i className="fad fa-telescope"></i>
                    </div>
                    <h4 className="display-3 subtitle">
                        {t("Pages." + this.props.typeOfList + ".NotFound")}
                    </h4>
                </div>
            </div>
        );
    }

    renderTreeNode = indices => {

        let start = this.props.defaultIndexValue;
        let IndexId = (this.state.currentItem && this.state.currentItem.id) ? parseInt(this.state.currentItem.id) : start;

        var indexNodes = this.GetNode(indices.nodes, IndexId);
        if (indexNodes && indexNodes.length > 0) {
            return <div className="d-flex flex-wrap justify-content-center justify-content-sm-around">
                {
                    indexNodes.map(item => {
                        return <div className="pr-1 bookWrap mb-3 " key={item.id}>
                            <Link to="#" className='w-100' onClick={() => this.setCurrentItem(item)}>
                                <div className="shop-item mb-0">
                                    <div className="product-thumb">
                                        {
                                            item.icon ?
                                                <LazyLoadImage src={item.icon} alt={`${item.label}`} />
                                                :
                                                <LazyLoadImage src="/assets/images/logo/130p150.png" alt={`${item.label}`} />
                                        }
                                    </div>
                                    <div className="product-content">
                                        <h5 className="title">{item.label}</h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    })
                }
            </div>
        }
        return <></>;
    }

    renderSubLessons(IsPublic, filterLesson, toRemove, classRooms, user, indices) {
        return filterLesson.filter(p => p.IsPublic === IsPublic).sort((a, b) => a.Sort > b.Sort ? 1 : -1).map(lesson =>
            (toRemove && toRemove.includes(lesson.Id)) ? "" :
                <LessonItem
                    setFavorite={this.setFavorite}
                    classRooms={classRooms}
                    getStudent={this.fetchStudentInClassRooms}
                    user={user}
                    type={this.props.typeOfLesson}
                    key={lesson.Id}
                    IsAdmin={false}
                    setIndex={this.setCurrentItem}
                    lesson={lesson}
                    indices={indices.nodes} />
        );
    }

    renderPath() {
        this.pathList = [];
        this.getNodePath(this.props.indices?.nodes, this.state.currentItem?.id, this.props.typeOfList === "Games" ? 0 : 1);
        if (this.pathList) {
            const length = this.pathList.length;
            return this.pathList.reverse().map((node, index) => {
                return (
                    <span
                        key={node.id}>
                        <Link
                            onClick={() => this.setCurrentItem(node)}
                            to="#">
                            {node.label}
                        </Link>
                        {(length !== index + 1) ? <i className="fas fa-arrow-left text-info m-2"></i> : ""}
                    </span>
                );
            });
        }
        return "";
    }

    getNodePath(nodes, currentId, Level) {
        if (nodes) {
            nodes.forEach(node => {
                const isOpen = this.HasNode(node, currentId);
                if (isOpen) {
                    this.getNodePath(node.nodes, currentId, Level);
                    if (node.Level > Level) {
                        this.pathList.push(node);
                    }
                }
            });
        }
    }

    HasNode(node, currentId) {
        if (node) {
            return (currentId === node.id) || this.hasSelectedNodeInChildren(node.nodes, currentId);
        }
        return false;
    }

    hasSelectedNodeInChildren(nodes, currentId) {
        var result = false;
        nodes.forEach(node => {
            result = result || (currentId === node.id) || this.hasSelectedNodeInChildren(node.nodes, currentId);
        });
        return result;
    }
    toggleTopicFilter = topicId => {
        this.setState(prevState => {
            const selectedTopicIds = prevState.selectedTopicIds || [];
            if (selectedTopicIds.includes(topicId)) {
                return { selectedTopicIds: selectedTopicIds.filter(id => id !== topicId) };
            } else {
                return { selectedTopicIds: [...selectedTopicIds, topicId] };
            }
        });
    }

    render() {

        const { t, startFrom } = this.props;

        let indices = this.props.indices;
        if (indices) {
            setIndeices(indices);
        } else {
            indices = this.state.indices;
        }

        let IndexId = (this.state.currentItem) ? parseInt(this.state.currentItem.id) : 0;

        let start = this.props.defaultIndexValue;
        if (startFrom) {
            start = startFrom;
        }

        let lessons = this.props.lessons;
        const getLessonTopics = (lesson) => {
            return lesson.Topics || [];
        };

        const allTopicsMap = new Map();
        if (lessons && lessons.lessons && lessons.lessons.length > 0 && this.state.currentItem) {
            const currentCategoryLessons = lessons.lessons.filter(v => v.Index.Id === this.state.currentItem.id);
            currentCategoryLessons.forEach(lesson => {
                const topics = getLessonTopics(lesson);
                topics.forEach(topic => {
                    allTopicsMap.set(topic.TopicId, topic.TopicName);
                });
            });
        }
        const availableTopics = Array.from(allTopicsMap.entries()).map(([id, name]) => ({ id, name }));

        return (
            <>
                <Helmet>
                    <title>{t('PageHeader.' + this.props.typeOfList)} {this.props.title ? ` - ${this.props.title}` : ""} | {t('alarabeyya')}</title>

                    <meta property="og:title" content={t("PageHeader." + this.props.typeOfList) + " - " + this.props.title + ' | ' + t('alarabeyya')} />
                    <meta property="twitter:title" content={t("PageHeader." + this.props.typeOfList) + " - " + this.props.title + ' | ' + t('alarabeyya')} />

                    <meta name="description" content={t('PageHeader.' + this.props.typeOfList + '_desc')} />
                    <meta property="og:description" content={t('PageHeader.' + this.props.typeOfList + '_desc')} />
                    <meta property="twitter:description" content={t('PageHeader.' + this.props.typeOfList + '_desc')} />
                </Helmet>

                <section className="position-relative" id={`main-${this.props.typeOfList}-section`} style={{
                    minHeight: '100vh'
                }}>
                    {this.props.Background}
                    <div className="container padding-top padding-bottom">
                        <div className="row justify-content-center w-100" data-aos="fade-top" data-aos-easing="linear">
                            <div className="section-header mb-4">
                                {
                                    this.props.typeOfList === "Games" ? "" : <span className="cate custome-title"> {t('PageHeader.StudyTrack')} </span>
                                }
                                <div className="display-4 h3 custome-title" ><i className={`mx-3 ${this.props.Icon}`}></i> {t('PageHeader.' + this.props.typeOfList)} {this.props.title ? ` - ${this.props.title}` : ""}</div>
                            </div>
                        </div>
                        {
                            this.props.typeOfList === "Games" ? "" :
                                <div className="d-none d-lg-block" data-aos="fade-bottom" data-aos-easing="linear">
                                    <SubMenu />
                                </div>
                        }

                        <div className="row mb-30-none">
                            <div className="col-lg-4 mb-50 d-none d-lg-block">
                                {indices ?
                                    <TreeView
                                        IsAdmin={false}
                                        title={this.props.title}
                                        parentId={this.props.parentId}
                                        currentId={IndexId}
                                        data={indices.nodes}
                                        startFrom={start}
                                        type={this.props.typeOfTree}
                                        toRemove={indices.toRemove}
                                        setCurrentItem={this.setCurrentItem}></TreeView>
                                    : ""
                                }
                            </div>

                            <div className="col-lg-8 mb-50">
                                <div className="widget widget-search" >
                                    <div className="widget-body">
                                        <div className="d-flex align-items-center">
                                            <div className="p-2 flex-grow-1">
                                                <form className="search-form m-0">
                                                    <input type="text" onChange={e => this.setSearch(e.target.value)} value={this.state.search} placeholder={t("Pages." + this.props.typeOfList + ".search")} />
                                                    <button type="button"><i className="fas fa-search"></i></button>
                                                </form>
                                            </div>
                                            {availableTopics && availableTopics.length > 0 && (
                                                <div className="p-2">
                                                    <OverlayTrigger
                                                        trigger="click"
                                                        rootClose
                                                        placement="bottom-end"
                                                        overlay={
                                                            <Popover id="popover-filter-topics" style={{ direction: 'rtl', textAlign: 'right', minWidth: '220px' }}>
                                                                <Popover.Title as="h3">{t("FilterByTopic") || "تصفية حسب الموضوع"}</Popover.Title>
                                                                <Popover.Content style={{ maxHeight: '250px', overflowY: 'auto', padding: '0' }}>
                                                                    <div className="d-flex flex-column">
                                                                        {availableTopics.map(topic => {
                                                                            const isSelected = this.state.selectedTopicIds?.includes(topic.id);
                                                                            return (
                                                                                <div 
                                                                                    key={topic.id} 
                                                                                    onClick={() => this.toggleTopicFilter(topic.id)}
                                                                                    className="d-flex align-items-center py-2 px-3 topic-item-row"
                                                                                    style={{
                                                                                        borderBottom: '1px solid #f1f2f6',
                                                                                        cursor: 'pointer',
                                                                                        userSelect: 'none',
                                                                                        transition: 'background-color 0.2s',
                                                                                        backgroundColor: isSelected ? 'rgba(146, 39, 143, 0.05)' : 'transparent'
                                                                                    }}
                                                                                >
                                                                                    <div className="ml-2">
                                                                                        <i className={isSelected ? "fas fa-check-square text-primary" : "far fa-square text-muted"} style={{ fontSize: '16px' }}></i>
                                                                                    </div>
                                                                                    <div className="text-right flex-grow-1" style={{ fontSize: '13px', fontWeight: isSelected ? 'bold' : 'normal' }}>
                                                                                        {topic.name}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </Popover.Content>
                                                            </Popover>
                                                        }
                                                    >
                                                        <button 
                                                            type="button" 
                                                            className="btn p-0 d-flex align-items-center justify-content-center position-relative"
                                                            style={{
                                                                width: '45px',
                                                                height: '45px',
                                                                borderRadius: '8px',
                                                                backgroundColor: this.state.selectedTopicIds?.length > 0 ? '#92278f' : '#f8f9fa',
                                                                color: this.state.selectedTopicIds?.length > 0 ? '#fff' : '#92278f',
                                                                border: '1px solid rgba(146, 39, 143, 0.15)',
                                                                boxShadow: this.state.selectedTopicIds?.length > 0 ? '0 3px 8px rgba(146, 39, 143, 0.3)' : 'none',
                                                                transition: 'all 0.3s ease',
                                                                cursor: 'pointer'
                                                            }}
                                                            title={t("FilterByTopic") || "تصفية حسب الموضوع"}
                                                        >
                                                            <i className="fad fa-tags" style={{ fontSize: '18px' }}></i>
                                                            {this.state.selectedTopicIds?.length > 0 && (
                                                                <span 
                                                                    className="position-absolute badge badge-pill badge-danger" 
                                                                    style={{
                                                                        top: '-5px',
                                                                        right: '-5px',
                                                                        fontSize: '9px',
                                                                        padding: '2px 5px',
                                                                        backgroundColor: '#ff4d4f',
                                                                        color: '#fff',
                                                                        borderRadius: '50%',
                                                                        minWidth: '15px',
                                                                        height: '15px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        border: '1.5px solid #fff'
                                                                    }}
                                                                >
                                                                    {this.state.selectedTopicIds.length}
                                                                </span>
                                                            )}
                                                        </button>
                                                    </OverlayTrigger>
                                                </div>
                                            )}
                                        </div>
                                        <div className="pt-2">
                                            {this.renderPath()}
                                        </div>
                                        {this.state.selectedTopicIds && this.state.selectedTopicIds.length > 0 && (
                                            <div className="selected-topics-container mt-3 pt-2 d-flex flex-wrap align-items-center" style={{ gap: '8px', direction: 'rtl', borderTop: '1px dashed rgba(146, 39, 143, 0.15)' }}>
                                                <span className="small text-muted ml-2" style={{ fontSize: '12px' }}>
                                                    <i className="fad fa-filter text-info ml-1"></i> {t("SelectedTopics") || "المواضيع المختارة:"}
                                                </span>
                                                {this.state.selectedTopicIds.map(id => {
                                                    const topicName = availableTopics.find(t => t.id === id)?.name || id;
                                                    return (
                                                        <span 
                                                            key={id} 
                                                            className="badge badge-pill d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: 'rgba(146, 39, 143, 0.08)',
                                                                color: '#92278f',
                                                                padding: '4px 10px',
                                                                fontSize: '12px',
                                                                border: '1px solid rgba(146, 39, 143, 0.2)',
                                                                gap: '6px'
                                                            }}
                                                        >
                                                            {topicName}
                                                            <i 
                                                                className="fas fa-times text-danger cursor-pointer mr-1" 
                                                                onClick={() => this.toggleTopicFilter(id)}
                                                                style={{ cursor: 'pointer', fontSize: '11px' }}
                                                            ></i>
                                                        </span>
                                                    );
                                                })}
                                                <button
                                                    type="button"
                                                    onClick={() => this.setState({ selectedTopicIds: [] })}
                                                    className="btn btn-sm btn-link text-danger m-0 p-0 mr-2"
                                                    style={{ fontSize: '12px', textDecoration: 'none' }}
                                                >
                                                    {t("ClearFilter") || "إلغاء التصفية"}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.renderLessons()}
                            </div>

                        </div>
                    </div>
                </section>
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        studentInClassRooms: state.studentInClassRooms,
        classRooms: state.classRooms,
        user: state.user,
        indices: state.indices,
        lessons: state.lessons
    };
};

export default connect(mapStateToProps, { fetchStudentInClassRooms, fetchClassRooms, fetchIndices, fetch, setFavorite })(withTranslation('common')(List));